module.exports = __webpack_public_path__ + "img/GTWM_Main_01.d27247ea.png";